<div class="card-vehicle-modal-title language">
	<div class="mb-0 gb-headline2" role="heading" aria-level="2">
		<span [translate]="'activeVehicle_addMileageTitle'"></span>
	</div>
	<button type="button" class="close-modal" (click)="dismissAddModal()"
		aria-hidden="false" aria-label="'aoda_close_modal_label' | cms | async">
		<span aria-hidden="true" class="icon-ui-closedot gb-body1"></span>
	</button>
	<hr>
</div>

<!-- ERROR ALERT:ADD MILEAGE  -->
<div [hidden]="!showAddMileageError">
	<div class="row">
		<div class="col-12">
			<div class="alert alert-danger">
				<span data-aria-hidden="true" class="icon-ui-attention"></span>
				<div class="card-body-alert danger">
					<p><label [translate]="'activeVehicle_addMileageErrorMsg'"></label></p>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- ERROR ALERT:INVALID MILEAGE  -->
<div [hidden]="!invalidMileageError">
	<div class="row">
		<div class="col-12">
			<div class="alert alert-danger">
				<span data-aria-hidden="true" class="icon-ui-attention"></span>
				<div class="card-body-alert danger">
					<p><label [translate]="'activeVehicle_invalidMileageError'"></label></p>
				</div>
			</div>
		</div>
	</div>
</div>


<div class="{{language}}"
	prop10="add mileage:textBox:enter mileage"
	[formGroup]="addMileageForm"
	>

	<ox-text-input 
		[inputName]="'addMileageInput'" 
		[classes]="'form-control'"
		[submitted]="submitted" 
		[validationType]="'odometer'" 
		[id]="'addMileageInput'"
		[placeHolderText]="''"
		[ariaLabel]="'addMileageInput'" 
		[label]="'activeVehicle_addVehicleMileage_mileageLabel'" 
		[formGroupInput]="addMileageForm"
		[formControlNameInput]="'addMileageInput'"
		class="mb-2">
	</ox-text-input>
	
	<button type="submit"
			class="gb-primary-button col-4 mt-4"
			(click)="addMileage()"
			gm-track-link="AddMileage:AddMileage"
			track-delay="true"
			track-type="o"
			prop10="add mileage:button:save">
		<span [translate]="'activeVehicle_saveMileageBtn'"></span>
	</button>
</div>

<!-- Confirmation Modal -->
<ox-general-modal
	[(show)]="showConfirmationModal"
	[options]="confirmationModalStyling"
	[bodyComponent]="confirmationModal"
	[bindingInputs]="confirmationInputs"
	[bindingOutputs]="confirmationOutputs">
</ox-general-modal>
